import {
  type AnswerData,
  type GroupTranslation,
  type NeedAnalysisGroupItem,
  type Question,
  type hfb,
} from "@repo/api";
import isEmpty from "lodash/isEmpty";

export const filterGroups = (
  groups: NeedAnalysisGroupItem[],
  selectedHfbs?: hfb[],
  service?: string,
  showB2BTab?: boolean
) => {
  if (isEmpty(groups)) {
    return [];
  }

  return groups.filter((group) => {
    const isB2BGroup = group.group_name_key === "B2B";

    if (isB2BGroup && !showB2BTab) {
      return false;
    }

    // TODO: Change to only array after types are fixed in Config Tool
    const groupHfbs = Array.isArray(group.hfbs) ? group.hfbs : [group.hfbs];
    const hasMatchingHfb = groupHfbs.some((groupHfb) =>
      selectedHfbs?.includes(groupHfb)
    );

    return (
      hasMatchingHfb ||
      (service && group.service?.includes(service)) ||
      (showB2BTab && isB2BGroup)
    );
  });
};

export const getQuestionsLength = (
  groups: NeedAnalysisGroupItem[],
  selectedHfbs: hfb[],
  service?: string
): number => {
  if (isEmpty(groups)) {
    return 0;
  }

  const selectedGroups = filterGroups(groups, selectedHfbs, service);

  const totalLength = isEmpty(selectedGroups)
    ? 0
    : selectedGroups?.reduce(
        (total, group) => total + (group.questions?.length ?? 0),
        0
      );

  return totalLength;
};

export const getAnswersLength = (
  selectedHfbs: hfb[],
  answersData: AnswerData[],
  questionsData: Question[],
  groups: NeedAnalysisGroupItem[],
  service?: string
): number => {
  if (
    isEmpty(selectedHfbs) ||
    isEmpty(answersData) ||
    isEmpty(questionsData) ||
    isEmpty(groups)
  ) {
    return 0;
  }

  const selectedGroups = filterGroups(groups, selectedHfbs, service);

  if (!selectedGroups) {
    return 0;
  }

  const totalAnsweredQuestions =
    selectedGroups.flatMap((selectedGroup) =>
      selectedGroup.questions?.filter((question) => {
        const selectedQuestion = questionsData.find(
          (q) => q.question_id_key === question.question_id_key
        );

        const answerData = answersData.find(
          (a) => a.questionId === question.question_id_key
        );

        return (
          selectedQuestion &&
          answerData &&
          ((selectedQuestion.answers && answerData.answerIds?.length) ||
            (!selectedQuestion.answers && answerData.answerFreeText !== ""))
        );
      })
    )?.length ?? 0;

  return totalAnsweredQuestions;
};

export const getTranslation = (
  groupTranslation: GroupTranslation[],
  language: string,
  title: string
) => {
  if (groupTranslation) {
    const languageTranslation = groupTranslation.find(
      (translation: GroupTranslation) => translation.language_key === language
    );
    return languageTranslation ? languageTranslation.translation : title;
  }

  return title;
};
